import { render } from "./ResidentialFloorDetail.vue?vue&type=template&id=22d0e3d6&scoped=true"
import script from "./ResidentialFloorDetail.vue?vue&type=script&lang=js"
export * from "./ResidentialFloorDetail.vue?vue&type=script&lang=js"

import "./ResidentialFloorDetail.vue?vue&type=style&index=0&id=22d0e3d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d0e3d6"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QIcon,QBtnToggle,QBtn,QTooltip});
